module.exports = __webpack_public_path__ + "assets/static/png/icon_info.87b0dc84cfe8dd1e412528a9c7f0f099.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myCards/images/icon_info.png
 ** module id = 21
 ** module chunks = 1
 **/